import { render } from "./Reflection.vue?vue&type=template&id=78f0144a&scoped=true"
import script from "./Reflection.vue?vue&type=script&lang=js"
export * from "./Reflection.vue?vue&type=script&lang=js"

import "./Reflection.vue?vue&type=style&index=0&id=78f0144a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f0144a"]])

export default __exports__